import OpenLayersTileLayer from 'ol/layer/Tile';
import { XYZ } from 'ol/source';
import { useEffect, useRef } from 'react';
import { useBaseElement } from './useElement';

class BlueTileSource extends XYZ {
  private color: string;

  constructor(color: string) {
    const canvas = document.createElement('canvas');
    canvas.width = 256;
    canvas.height = 256;
    const ctx = canvas.getContext('2d');
    if (ctx) {
      ctx.fillStyle = color;
      ctx.fillRect(0, 0, 256, 256);
    }
    const dataUrl = canvas.toDataURL();

    super({
      url: dataUrl,
      maxZoom: 19,
    });
    this.color = color;
  }
}

interface BlueTileLayerProps {
  color?: string;
}

export function BlueTileLayer({ color = '#aad3df' }: BlueTileLayerProps) {
  const elementRef = useRef(
    new OpenLayersTileLayer({
      source: new BlueTileSource(color),
      zIndex: 0,
    }),
  );

  useBaseElement(elementRef.current, 'blue');

  useEffect(() => {
    const newSource = new BlueTileSource(color);
    elementRef.current.setSource(newSource);
  }, [color]);

  return null;
}
